import styled from "styled-components";

export const WishlistItems = styled.ul`
    padding: 24px 0px;
    display: grid;
    grid-template-columns: repeat(1,1fr);
    gap: 30px;
    @media(min-width: 768px) {
        padding: 8px 0px;
        gap: 10px;

       } 
    
`

export const WithoutWishlist = styled.div`
display: flex;
justify-content: center;

color: ${props => props.theme.colors.typography1.pure};
font-weight: 500;
line-height: 40px;

padding: 10px 0px;
font-size: 1rem;


@media(min-width:480px) {
    font-size: 2rem;
    padding: 24px 0px;
}

@media(min-width:768px) {
    font-size: 1rem;
    line-height: 20px;
    padding: 15px 0px;

}
   

`

